export function getFormattedTextFromEmailBody(emailBody: string): string {
  const html = cleanEmailHtml(emailBody);
  return `<div>${html.replace(/\n/g, '<br>')}</div>`;
}

export type EmailBodyFormatResult = {
  html: string;
  kind: 'html' | 'text';
};

export function formatEmailBody(rawBody: string | null | undefined): EmailBodyFormatResult {
  const raw = (rawBody ?? '').trim();
  if (!raw) return { html: '', kind: 'text' };

  const decoded = decodePossiblyJsonEscapedString(raw);

  // HTML path
  if (looksLikeHtml(decoded)) {
    const cleaned = cleanEmailHtml(stripFontTags(decoded));
    return { html: cleaned, kind: 'html' };
  }

  // Plain text path
  return {
    html: formatPlainText(decoded),
    kind: 'text'
  };
}

// Helpers

export function decodePossiblyJsonEscapedString(s: string): string {
  if (s.includes('\\"') || s.includes('\\n') || s.includes('\\t') || s.includes('\\r')) {
    try {
      return JSON.parse(`"${s.replace(/"/g, '\\"')}"`);
    } catch {
      return s.replace(/\\"/g, '"').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t');
    }
  }
  return s;
}

export function looksLikeHtml(s: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(s);
}

export function stripFontTags(html: string): string {
  return html.replace(/<\/?font[^>]*>/gi, '');
}

export function formatPlainText(text: string): string {
  const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  return `<div>${escaped.replace(/\r?\n/g, '<br>')}</div>`;
}

export function cleanEmailHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.querySelectorAll('p').forEach((p) => {
    const text = (p.textContent ?? '').replace(/\u00A0/g, ' ').trim();

    const onlyBr = p.children.length === 1 && p.children[0].tagName === 'BR';

    if (!text || onlyBr) {
      p.remove();
    }
  });

  return doc.body?.innerHTML ?? html;
}
